import type { FC } from 'react';
import { Navigate } from 'react-router';
import { PageSpinner } from 'src/components/spinner-container';
import {
  defaultTransportTabPath,
  transportTabPathname,
} from 'src/pages/company-transactions/transport/tabs';
import { useCompanyTransactionsAccess } from 'src/pages/company-transactions/use-company-transactions-access';
import { ReportingTransactions } from 'src/pages/reporting/my-transactions';

export const MyTransactionsRedirect: FC = () => {
  const access = useCompanyTransactionsAccess();

  if (!access.loaded) return <PageSpinner />;

  if (!access.canAccess) return <ReportingTransactions />;

  return (
    <Navigate replace to={transportTabPathname(defaultTransportTabPath)} />
  );
};
